import _styled from "@emotion/styled/base";
export const ImageGrid = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1gzyko0"
} : {
  target: "e1gzyko0",
  label: "ImageGrid"
})(({
  spacing = 0.75
}) => `
  display: grid;
  grid-auto-flow: column;
  column-gap: ${spacing}rem;
  user-select: none;
`, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkltYWdlR3JpZC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDeUIiLCJmaWxlIjoiSW1hZ2VHcmlkLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuZXhwb3J0IGNvbnN0IEltYWdlR3JpZCA9IHN0eWxlZC5kaXYoKHsgc3BhY2luZyA9IDAuNzUgfSkgPT4gYFxuICBkaXNwbGF5OiBncmlkO1xuICBncmlkLWF1dG8tZmxvdzogY29sdW1uO1xuICBjb2x1bW4tZ2FwOiAke3NwYWNpbmd9cmVtO1xuICB1c2VyLXNlbGVjdDogbm9uZTtcbmApO1xuLy8jIHNvdXJjZU1hcHBpbmdVUkw9SW1hZ2VHcmlkLmpzLm1hcCJdfQ== */");